import classNames from "classnames"
import rollBtnBackground from "@/images/roll-button.webp"
import { ButtonHTMLAttributes, DetailedHTMLProps } from "react"

type ButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>

export const PrimaryButton: React.FC<ButtonProps> = ({
  className,
  ...rest
}) => {
  return (
    <button
      className={classNames(
        ` ${className} roll hover:brightness-125 h-fit transition-all px-2 duration-150 relative text-2xl text-[#531F49] font-poppins font-semibold `
      )}
      {...rest}
    >
      <img src={rollBtnBackground} className="h-16 w-full "></img>
      <div
        className={classNames(
          "absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-2/3 w-full justify-center flex"
        )}
      >
        {rest.children}
      </div>
    </button>
  )
}
